// Encapsulates the apply-fix API call, surfacing AmazonValidationError separately from hard failures.
import { useCallback } from 'react';
import { applyFix, AmazonValidationError } from '../services/catalogueHealthApi';

const useFixApplication = (token, { skuId, asin, productName, productType }) => {
  // Returns { success, submissionId } or { amazonIssues } or throws on hard failure.
  const apply = useCallback(
    async (fixState, issue) => {
      try {
        const data = await applyFix(token, {
          sku: skuId,
          asin,
          product_title: productName,
          product_type: productType,
          attribute: fixState.attribute,
          proposed_value: fixState.editableValue,
          old_value: fixState.currentValue ?? '',
          issue_code: issue?.code ?? '',
          issue_message: issue?.message ?? '',
          reason: fixState.reason ?? '',
        });
        return { success: true, submissionId: data.submission_id || '' };
      } catch (err) {
        if (err instanceof AmazonValidationError) {
          return { success: false, amazonIssues: err.amazonIssues };
        }
        throw err;
      }
    },
    [token, skuId, asin, productName, productType]
  );

  return { apply };
};

export default useFixApplication;
